<template>
    <DModal
        :show="showModal"
        :title="__('administrations.sanity_checks.web_card.modal_title')"
        is-confirm
        @confirm="confirm"
        @close="$emit('close-modal')"
    >
        <DCard padding>
            <template #default>
                <DFormRow
                    :label="__('administrations.sanity_checks.web_card.id')"
                    :is-required="true"
                >
                    <DInput
                        id="webcard_id"
                        v-model="webCardId"
                        maxlength="128"
                    />
                </DFormRow>
            </template>
        </DCard>
    </DModal>
</template>

<script>

export default {
    name: 'WebCardModal',
    props: {
        showModal: {
            type: Boolean,
            default: false
        },
        item: {
            type: Object,
            default: () => { return {} }
        }
    },
    emits: ['close-modal', 'confirm'],
    data () {
        return {
            webCardId: ''
        }
    },
    methods: {
        confirm () {
            this.$emit('confirm', { web_card_id: this.webCardId, item: this.item })
        }
    }
}
</script>

<style lang="scss" scoped>
.loading {
    padding: 40px 0;
    display: flex;
    justify-content: center;

    & .mdi {
        animation: loadingAnim 0.4s infinite linear;
    }
}
@keyframes loadingAnim {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}
</style>
